<template>
    <div>
        <div v-if="!gotData">
            <sau-loading>
                <template slot="message">Fetching Performance Metrics</template>
            </sau-loading>
        </div>
        <div v-else-if="hasMetrics">
            <div class="row">
                <div class="col">

                    <div v-for="(graph, index) in graphs" :key="index" class="pb-6">
                        <!-- classes based off index -->
                        <h4>{{ graph.title }}</h4>
                        <div class="sau-bx bx-pad">
                            <canvas :id="graphId(graph.title)" style="height:300px; width:100%;" :class="determineClass(graph.title)" :data-points="JSON.stringify(graph.data)"></canvas>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div v-else>

            <sau-apiro-response type="error" support="true">
                <template slot="message">Unable to retrieve performance metrics.</template>
                <template slot="details">
                    <p>If you have any questions please contact support.</p>
                </template>
            </sau-apiro-response>

        </div>
    </div>
</template>
<script>
import jsFunctions from '@js/store/jqueryFunctions';
export default {
    mixins: [jsFunctions],
    data() {
        return {
            graphs: [],
            hasMetrics: false,
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getPerformanceMetrics().then(response => {
                if(response.data) {
                    this.hasMetrics = true;
                    this.graphs = response.data.metrics;
                    let count = Object.keys(this.graphs).length;
                    this.$nextTick(() => {
                        // tell how many graphs to draw
                        this.registerAnimateOnView(count);
                    });
                }
            }).catch(error => {
            });
        },
        graphId(title) {
            return 'graph-' + title.replace(' ','-').toLowerCase();
        },
        determineClass(title) {
            return title.toLowerCase().includes('cpu') ? 'lazy-single-line-graph' : title.toLowerCase().includes('memory') ? 'lazy-single-line-graph' : 'lazy-double-line-graph';
        }
    },
    computed: {
        consoleLink() {
            return '/service/' + this.getServiceType() + '/' + this.getServiceId() + '/console/' + this.host + '/' + this.token;
        },
    }
}
</script>
<style>
</style>
